// src/components/lesson/FurtherReading.tsx
//
// "Further reading" on a lesson page: blog articles curated for this topic
// (blog-learn-links.ts, resolved server-side in the lesson page to posts that
// actually exist). Presentational only, so it's testable without the full
// LessonClient harness.

import Link from 'next/link'
import { BookOpen } from 'lucide-react'

export interface FurtherReadingPost {
  slug: string
  title: string
  category: string
  readingMinutes: number
}

export default function FurtherReading({ posts }: { posts: FurtherReadingPost[] }) {
  if (posts.length === 0) return null

  return (
    <section className="mb-8">
      <h2 className="mb-3 flex items-center gap-2 text-xl font-semibold text-foreground">
        <BookOpen className="h-5 w-5 text-brand-ink" />
        Further reading
      </h2>
      <ul className="space-y-2">
        {posts.map((p) => (
          <li key={p.slug}>
            <Link
              href={`/blog/${p.slug}`}
              className="group flex items-baseline justify-between gap-3 rounded-xl border border-border bg-card/40 p-4 transition hover:border-brand/40 hover:bg-card/60"
            >
              <span className="text-sm font-medium text-foreground group-hover:text-brand-ink dark:group-hover:text-brand-ink">
                {p.title}
              </span>
              <span className="flex-shrink-0 text-xs text-muted-foreground">
                {p.category} · {p.readingMinutes} min
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  )
}
